// Cache
import { get, set, clear, del } from 'idb-keyval';

// Libs
import * as EventifyAPI from "../libs/EventifyAPI";
import * as UserContext from "../libs/UserContext";

// lodash
import {isEqual as _isEqual} from 'lodash-es'

// UUID
const uuidv4 = require('uuid/v4');

export default function ModelCache() { return }

export function assertModelArrayEqual() {

}

export function isStale(updated, seconds=10) {
  return (Date.now() - updated) > seconds*1000;
}

export function assertEqual(o1, o2) {
  if (o1 === null || typeof o1 === "undefined" ||
      o2 === null || typeof o2 === "undefined") {
    return false;
  }

  let same = _isEqual(o1, o2);

  return same;
};

// ---------------------------------------------------------------------------
// CACHE CONSTANTS
const StaleTime = {
  Person: 10,
  User: 60*60,
  List: 10,
}

let canUseIndexedDB = true;

const db = window.indexedDB.open('test');
db.onerror = function() {
  console.log("Can't use indexedDB");
  canUseIndexedDB = false;
}

// ---------------------------------------------------------------------------
// PERSON
export async function getPersonForId(personid, callback) {
  if (!canUseIndexedDB) {
    EventifyAPI.getPersonById(
      personid
    ).then( async (fetchedPersons) => {
      const apiResult = fetchedPersons[0];
      callback(apiResult);
    });
    return;
  }

  var cachePerson = await get("person_" + personid);
  if (typeof cachePerson === "undefined") {
    EventifyAPI.getPersonById(
      personid
    ).then( async (fetchedPersons) => {
      const apiResult = fetchedPersons[0];
      cachePerson = await setPersonForId(personid, apiResult);
      if (callback != null && typeof callback !== "undefined") {
        callback(cachePerson.obj);
      }
    });
  } else {
    if (callback != null && typeof callback !== "undefined") {
      callback(cachePerson.obj);
    }
    if (isStale(cachePerson.updated, StaleTime.Person)) {
      EventifyAPI.getPersonById(
        personid
      ).then( async (result) => {
        const apiResult = result[0];
        if (assertEqual(apiResult, cachePerson.obj) === false || isStale(cachePerson.updated, StaleTime.Person)) {
          cachePerson = await setPersonForId(personid, apiResult);
          if (callback != null && typeof callback !== "undefined") {
            callback(cachePerson.obj);
          }
        }
      });
    }
  }
}

export async function setPersonForId(personid, payload) {
  const cacheObject = {
    "obj": payload,
    "updated": Date.now()
  }
  await set("person_" + personid, cacheObject);
  return cacheObject;
}

// ---------------------------------------------------------------------------
// LIST
export async function getListForId(listid, callback) {
  if (!canUseIndexedDB) {
    EventifyAPI.getListById(
      listid
    ).then( async (fetchedLists) => {
      const apiResult = fetchedLists[0];
      if (apiResult != null && typeof apiResult !== "undefined") {
        callback(apiResult);
      }
    });
    return;
  }

  var cacheList = await get("list_" + listid);
  var cacheMiss = typeof cacheList === "undefined";
  var cacheCorrupt = false;
  if (cacheList !== null && typeof cacheList !== "undefined") {
    cacheCorrupt = cacheList.obj === null || typeof cacheList.obj === "undefined";
  }
  if (cacheMiss || cacheCorrupt) {
    EventifyAPI.getListById(
      listid
    ).then( async (fetchedLists) => {
      const apiResult = fetchedLists[0];
      if (apiResult != null && typeof apiResult !== "undefined") {
        cacheList = await setListForId(listid, apiResult);
        if (callback != null && typeof callback !== "undefined") {
          callback(cacheList.obj);
        }
      }
    });
  } else {
    if (callback != null && typeof callback !== "undefined") {
      callback(cacheList.obj);
    }

    if (isStale(cacheList.updated, StaleTime.List)) {
      EventifyAPI.getListById(
        listid
      ).then( async (fetchedLists) => {
        const apiResult = fetchedLists[0];
        if (assertEqual(apiResult, cacheList.obj) === false || isStale(cacheList.updated, StaleTime.List)) {
          cacheList = await setListForId(listid, apiResult);
          if (callback != null && typeof callback !== "undefined") {
            callback(cacheList.obj);
          }
        }
      });
    }
  }
}

export async function setListForId(listid, payload) {
  const cacheObject = {
    "obj": payload,
    "updated": Date.now()
  }
  await set("list_" + listid, cacheObject);
  return cacheObject;
}

export async function deleteListForId(listid, callback) {
  if (!canUseIndexedDB) {
    await EventifyAPI.deleteList(listid);
    if (callback != null && typeof callback !== "undefined") {
      callback(true);
    }
    return;
  }

  await clear();
  await EventifyAPI.deleteList(
    listid);
  if (callback != null && typeof callback !== "undefined") {
    callback(true);
  }
}

// ---------------------------------------------------------------------------
// MEMBERSHIP
export async function getMembershipForListId(listid, callback) {
  if (!canUseIndexedDB) {
    EventifyAPI.getFullMembershipForListId(
      listid
    ).then( async (fetchedMembership) => {
      const apiResult = fetchedMembership;
      if (callback != null && typeof callback !== "undefined") {
        callback(apiResult);
      }
    });
    return;
  }

  var cacheMembership = await get("listmembership_" + listid);
  var cacheMiss = typeof cacheMembership === "undefined";
  if (cacheMiss) {
    EventifyAPI.getFullMembershipForListId(
      listid
    ).then( async (fetchedMembership) => {
      const apiResult = fetchedMembership;
      cacheMembership = await setMembershipForListId(listid, apiResult);
      if (callback != null && typeof callback !== "undefined") {
        callback(cacheMembership.obj);
      }
    });
  } else {
    if (callback != null && typeof callback !== "undefined") {
      callback(cacheMembership.obj);
    }
    EventifyAPI.getFullMembershipForListId(
      listid
    ).then( async (fetchedMembership) => {
      const apiResult = fetchedMembership;
      if (assertEqual(apiResult, cacheMembership.obj) === false) {
        cacheMembership = await setMembershipForListId(listid, apiResult);
        if (callback != null && typeof callback !== "undefined") {
          callback(cacheMembership.obj);
        }
      }
    });
  }
}

export async function setMembershipForListId(listid, payload) {
  const cacheObject = {
    "obj": payload,
    "updated": Date.now()
  }
  await set("listmembership_" + listid, cacheObject);
  return cacheObject;
}

// ---------------------------------------------------------------------------
// USER
export async function getUserById(userid, callback) {
  if (!canUseIndexedDB) {
    EventifyAPI.getUserById(
      userid
    ).then( async (fetchedUsers) => {
      const apiResult = fetchedUsers[0];
      if (callback != null && typeof callback !== "undefined") {
        callback(apiResult);
      }
    });
    return;
  }

  var cacheUser = await get("user_" + userid);
  var cacheMiss = typeof cacheUser === "undefined";
  if (cacheMiss) {
    EventifyAPI.getUserById(
      userid
    ).then( async (fetchedUsers) => {
      const apiResult = fetchedUsers[0];
      if (apiResult != null && typeof apiResult !== "undefined") {
        cacheUser = await setUserForId(userid, apiResult);
        if (callback != null && typeof callback !== "undefined") {
          callback(cacheUser.obj);
        }
      }
    });
  } else {
    if (callback != null && typeof callback !== "undefined") {
      callback(cacheUser.obj);
    }
    if (isStale(cacheUser.updated, StaleTime.User)) {
      EventifyAPI.getUserById(
        userid
      ).then( async (fetchedUsers) => {
        const apiResult = fetchedUsers[0];
        if (assertEqual(apiResult, cacheUser.obj) === false || isStale(cacheUser.updated, StaleTime.Person)) {
          cacheUser = await setUserForId(userid, apiResult);
        }
        if (callback != null && typeof callback !== "undefined") {
          callback(cacheUser.obj);
        }
      });
    }
  }
}

export async function setUserForId(userid, payload) {
  const cacheObject = {
    "obj": payload,
    "updated": Date.now()
  }
  await set("user_" + userid, cacheObject);
  return cacheObject;
}

export async function getListsForPersonId(personid, callback) {
  if (!canUseIndexedDB) {
    EventifyAPI.getListsForPersonId(
      personid,
    ).then( async (fetchedLists) => {
      const apiResult = fetchedLists[0];
      if (callback != null && typeof callback !== "undefined") {
        callback(apiResult);
      }
    });
    return;
  }

  var cacheNote = await get("lists_" + personid);
  var cacheMiss = typeof cacheNote === "undefined";
  if (cacheMiss) {
    EventifyAPI.getListsForPersonId(
      personid,
    ).then( async (fetchedLists) => {
      const apiResult = fetchedLists[0];
      cacheNote = await setListsForPersonId(personid, apiResult);
      if (callback != null && typeof callback !== "undefined") {
        callback(cacheNote.obj);
      }
    });
  } else {
    if (callback != null && typeof callback !== "undefined") {
      callback(cacheNote.obj);
    }
    if (isStale(cacheNote.updated, StaleTime.List)) {
      EventifyAPI.getListsForPersonId(
        personid,
      ).then( async (fetchedLists) => {
        const apiResult = fetchedLists[0];
        cacheNote = await setListsForPersonId(personid, apiResult);
        if (callback != null && typeof callback !== "undefined") {
          callback(cacheNote.obj);
        }
      });
    }
  }
}

export async function setListsForPersonId(personid, payload) {
  const cacheObject = {
    "obj": payload,
    "updated": Date.now()
  }
  await set("lists_" + personid, cacheObject);
  return cacheObject;
}
